import * as yup from 'yup'

import { ALLOWED_CHARS } from 'constants/fieldsValidationValues'

const ACCEPTED_FILE_TYPES = ['image/jpg', 'image/png', 'image/jpeg']

const ACCEPTED_SCENE_FILE_TYPES = ['obj', 'fbx']


export const makeSceneSchema = (id: number, preview: string, scene: string) =>
  yup.object().shape({
    name: yup
      .string()
      .trim()
      .required('Name is a required field')
      .matches(ALLOWED_CHARS, `Name can only contain latin letters`)
      .min(3, 'Name should contain atleast 3 symbols')
      .max(60, 'Name should contain up to 60 symbols'),
    description: yup
      .string()
      .trim()
      .required('Description is a required field')
      .matches(ALLOWED_CHARS, `Description can only contain latin letters`)
      .min(3, 'Description should contain atleast 3 symbols')
      .max(255, 'Description should contain up to 255 symbols'),
    preview: yup
      .mixed()
      .test('fileRequired', 'Preview file is required', (value) => {
        if (id && preview) return true
        return !!value?.length
      })
      .test('fileSize', 'Maximum image size is 2MB', (value) => {
        if (!value?.length) return true // attachment is optional
        return value[0]?.size <= 2 * 2 ** 20
      })
      .test('fileSizeMin', 'Minimum image size is 1 byte', (value) => {
        if (!value?.length) return true // attachment is optional
        return value[0].size > 0
      })
      .test('fileType', 'Preview should be of .jpg, .jpeg or .png type', (value) => {
        if (!value?.length) return true
        return ACCEPTED_FILE_TYPES.includes(value[0].type)
      }),
      sceneFile: yup
      .mixed()
      .test('fileRequired', 'Scene file is required', (value) => {
        if (id && scene) return true
        return !!value?.length
      })
      .test('fileSize', 'Maximum scene file size is 20MB', (value) => {
        if (!value?.length) return true // attachment is optional
        return value[0]?.size <= 20 * 2 ** 20
      })
      .test('fileSizeMin', 'Minimum scene file size is 1 byte', (value) => {
        if (!value?.length) return true // attachment is optional
        return value[0].size > 0
      })
      .test('fileType', 'Scene file should be of .obj or .fbx type', (value) => {
        if (!value?.length) return true
        return ACCEPTED_SCENE_FILE_TYPES.includes(value[0].name.split('.').splice(-1)[0])
      }),
  })
